import { Stack, Text } from "@chakra-ui/react";
import * as React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { useBreadcrumbs } from "../../components/breadcrumbs";
import Page from "../../components/page";
import PageBody from "../../components/page-body";
import { SegmentedControl } from "../../components/segmented-control";
import { useWorkspaceURL } from "../../hooks";
import { brand } from "../../lib/brand";

export default function SettingsRoot() {
  const workspaceURL = useWorkspaceURL();
  const location = useLocation();
  const navigate = useNavigate();
  useBreadcrumbs([{ label: "Integrations" }]);

  const tabs = [
    { value: workspaceURL("settings/integrations"), label: "Integrations" },
    { value: workspaceURL("settings/integrations/pixel"), label: "Pixel" },
    { value: workspaceURL("settings/integrations/deals"), label: "Deals" },
  ];

  return (
    <Page>
      <Stack flex="1" gap="6">
        <Text color="fg.muted" fontSize="sm" lineHeight={"1.5" as any}>
          Connect {brand.productName} to your ad platforms, website, and deals
          so it can get to work for you.
        </Text>
        <SegmentedControl
          items={tabs}
          value={location.pathname}
          onValueChange={(value) => navigate(value)}
        />
        <PageBody>
          <Outlet />
        </PageBody>
      </Stack>
    </Page>
  );
}
